import React, { useState, useEffect } from "react";
import { Formik, Form, Field, FieldArray, ErrorMessage } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import {
  ToggleSwitchV2,
  TextField,
  SelectField,
  CheckBoxes,
  RadioButtons,
  TextFieldV2,
  DropDownField,
  Switch,
  StyledCheckBoxes,
  StyledRadioButtons,
} from "../../../Shared/CustomizedForms/FormElements";
import styled from "styled-components";
import { QuestionTypes } from "../../Helpers/LookUpValues";
import RegistrationsService from "../../RegistrationsService";
import _ from "lodash";

/// This Component shows the Attached Questions of Child Template in Step 2
function RegistrationQuestions(props) {
  const getFormElement = (
    idx,
    elementSchema,
    values,
    setValues,
    isDisabled
  ) => {
    const props = {
      name: elementSchema.uid,
      label: elementSchema.isRequired
        ? <>{elementSchema.label} <span style={{ color: 'red' }}>*</span></>
        : elementSchema.label,
      options: elementSchema.questionOptions,
      disabled: isDisabled,
      fee: elementSchema.fee || "0",
      // value: values.questions[idx][elementSchema.uid] || elementSchema.value,
    };
    if (elementSchema.questionType == QuestionTypes.Text) {
      return <TextField {...props} />;
    } else if (elementSchema.questionType == QuestionTypes.DropDown) {
      return <SelectField {...props} />;
    } else if (elementSchema.questionType == QuestionTypes.Switch) {
      return <ToggleSwitchV2 {...props} />;
    } else if (elementSchema.questionType == QuestionTypes.Checkboxes) {
      // return <CheckBoxes {...props} />;
      return <StyledCheckBoxes {...props} />;
    } else if (elementSchema.questionType == QuestionTypes.Radiobuttons) {
      return <StyledRadioButtons {...props} />;
    }
  };

  // A class does not have to have questions -- plenty are set up without any. Rendering the
  // empty card for those produced a step headed "Questions" with nothing in it and no
  // explanation, which reads as the page having failed to load. Reported from production by
  // the registration administrator, who took it for a fault in registering on behalf of
  // someone: the member picker sits directly above, so the blank space below looks like the
  // consequence of using it. It is not -- the same screen appears registering yourself.
  const hasQuestions = props.questions && Object.keys(props.questions).length > 0;
  if (!hasQuestions) {
    return (
      <div className="card m-3">
        <div className="p-4 text-center text-muted">
          <i className="fa fa-info-circle mr-2"></i>
          No questions have been added for this class. You can submit the registration as it is.
        </div>
      </div>
    );
  }

  return (
    <div className="card m-3">
      <div className="row">
        {props.questions &&
          props.values &&
          Object.keys(props.questions).map((key, ind) => (
            // key belongs on the outermost element of the map, not on FieldArray inside it;
            // without it React warns on every render of this component.
            <div className="col-md-6 com-sm-12" key={key}>
              <FieldArray name="questions" key={ind}>
                <div name="form-control" key={ind + 1}>
                  {getFormElement(
                    ind,
                    props.questions[key],
                    props.values,
                    props.setValues,
                    props.isDisabled
                  )}
                </div>
              </FieldArray>
            </div>
          ))}
      </div>
    </div>
  );
}

export default RegistrationQuestions;
const SwitchDiv = styled.div`
  @media (min-width: 576px) {
    padding-left: 2rem;
  }
`;
